<template>

    <div class="project">

        <div class="project-header">
            <a class="pr-15" href="#" @click.prevent="selectProject('console')">{{ model.name }}</a>
            <div v-if="model.favorite" class="star text-warning" @click="unfavoriteProject"><i class="fas fa-star"></i></div>
            <div v-else class="star text-muted" @click="favoriteProject"><i class="far fa-star"></i></div>
        </div>

        <div class="project-body">
            <div class="mb-10">
                <v-stats size="sm" :stats="stats" />
            </div>
            <ul class="menu">
                <li @click.prevent="selectProject('customers')">
                    <span><i class="icon fas fa-id-card mr-10"></i>Platform</span>
                    <i class="arrow fas fa-chevron-right"></i>
                </li>
                <li @click.prevent="selectProject('automations')">
                    <span><i class="icon fas fa-paper-plane mr-10"></i>Automations</span>
                    <i class="arrow fas fa-chevron-right"></i>
                </li>
                <li @click.prevent="selectProject('broadcasts')">
                    <span><i class="icon fas fa-envelope mr-10"></i>Broadcasts</span>
                    <i class="arrow fas fa-chevron-right"></i>
                </li>
                <li @click.prevent="selectProject('templates')">
                    <span><i class="icon fas fa-envelope-open-text mr-10"></i>Templates</span>
                    <i class="arrow fas fa-chevron-right"></i>
                </li>
                <li @click.prevent="selectProject('forms')">
                    <span><i class="icon fas fa-pen-to-square mr-10"></i>Forms</span>
                    <i class="arrow fas fa-chevron-right"></i>
                </li>
                <li @click.prevent="selectProject('settings')">
                    <span><i class="icon fas fa-toolbox mr-10"></i>Settings</span>
                    <i class="arrow fas fa-chevron-right"></i>
                </li>
            </ul>
        </div>

        <div class="project-footer">
            <v-button size="xs" btn-style="white" @click.native="editProject">Edit</v-button>
            <v-button size="sm" :loading="loading" @click.native="selectProject('customers')">Select Project</v-button>
        </div>

    </div>

</template>

<style scoped lang="scss">

    .project {
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 5px;
        overflow: hidden;
        .project-header {
            @include font-semibold(14px);
            align-items: center;
            border-top: 2px solid $color-primary;
            display: flex;
            justify-content: space-between;
            padding: 15px;
            white-space: nowrap;
            a {
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
            }
            .star {
                cursor: pointer;
                transition: opacity .3s;
                &:hover {
                    opacity: 0.5;
                }
            }
        }
        .project-body {
            border-top: 1px solid $color-rule;
            padding: 15px;
            .menu {
                border: 1px solid $color-rule;
                border-radius: 5px;
                list-style: none;
                margin: 0;
                padding: 10px 0;
                li {
                    @include font-medium(14px);
                    align-items: center;
                    color: $color-text;
                    cursor: pointer;
                    display: flex;
                    justify-content: space-between;
                    padding: 5px 15px;
                    text-decoration: none;
                    transition: background-color .3s, color .3s;
                    &:hover {
                        background: $color-highlight;
                        color: $color-primary;
                    }
                    .arrow {
                        opacity: 0.5;
                    }
                }

            }
        }
        .project-footer {
            align-items: center;
            background: #fff;
            border-top: 1px solid $color-rule;
            display: flex;
            justify-content: space-between;
            padding: 15px;
        }
    }

</style>

<script>

import CurrencyUtil from '@utils/CurrencyUtil';
import MemberApi from '@api/MemberApi';
import numeral from 'numeral';
import UserApi from '@api/UserApi';

export default {

    props: {
        model: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
        }
    },

    computed: {

        user() {
            return this.$store.getters.user;
        },

        stats() {
            return [
                {
                    label: 'Customers',
                    value: numeral(this.model.customers_count).format('0,0'),
                },
                {
                    label: 'Revenue',
                    value: CurrencyUtil.format(this.model.charges_sum / 100, this.model),
                },
            ];
        },

    },

    methods: {

        editProject() {
            this.$emit('editProject', this.model);
        },

        favoriteProject() {
            MemberApi.favoriteProject(this.$store.getters.user.member.id, this.model.id)
                .then((response) => {
                    this.$emit('saved');
                }, (error) => {
                    this.$store.commit('setAlertWithError', error);
                });
        },

        unfavoriteProject() {
            MemberApi.unfavoriteProject(this.$store.getters.user.member.id, this.model.id)
                .then((response) => {
                    this.$emit('saved');
                }, (error) => {
                    this.$store.commit('setAlertWithError', error);
                });
        },

        selectProject(name) {
            this.loading = true;
            UserApi.updateProject(this.model.id)
                .then((response) => {
                    this.loading = false;
                    this.$router.push({ name: name });
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
